import i18next, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import { namespaces } from "./i18n.constants";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getConfig } from "services/config.service";

const translation = async (init: InitOptions) => {
  if (!i18next?.isInitialized) {
    await i18next
      .use(initReactI18next)
      .use(ChainedBackend)
      .use(LanguageDetector)
      .init(init);
  }
};

export const initOptions = () => {
  return {
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          defaultVersion: "1.0",
          expirationTime: getConfig().name === "dev" ? 0 : 60 * 1000, // 1 min
        },
        {
          loadPath: "/mceapi/localization/{{ns}}?language={{lng}}",
        },
      ],
    },
    react: {
      useSuspense: true, // Suspense added to App.tsx
    },
    detection: {
      caches: [],
      excludeCacheFor: [],
      order: ["navigator"],
    },
    ns: [namespaces.MPI, namespaces.COMMON, namespaces.ERROR],
    defaultNS: namespaces.MPI,
    fallbackLng: "de",
  };
};

export const initTranslation = () => {
  translation(initOptions());
};

export default i18next;
